
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Paytype } from '../../../models/paytype.model';
import { AlertService } from '../../../services/alert.service';


@Component({
    selector: 'create-edit-paytype-modal',
    template: require('./create-edit-paytype-modal.component.html'),
    styles: [require('./create-edit-paytype-modal.component.css')]
})
export class CreateEditPaytypeModalComponent {
    currentPaytype: Paytype;
    isCreatNew: boolean;
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditPaytypeModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentPaytype.paytypeId == undefined);
        this.currentPaytype = data.currentPaytype;
       
    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updatePaytype(this.currentPaytype).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Paytype successfully");
                }
            });
        } else {
            this.apiService.createPaytype(this.currentPaytype).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Paytype successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/paytypes/create-edit-paytype-modal/create-edit-paytype-modal.component.ts